$(function (){
    /* perfect scrollbar */
    new PerfectScrollbar('#custom-scroll-cards', {
        suppressScrollY: true
    });
    new PerfectScrollbar('#custom-scroll-kabar', {
        suppressScrollY: true
    });

    /* socmed share */
    var currentLocation = window.location.href;
	$('a.socmed-share').on('click', function(e){
		e.stopPropagation();
		e.preventDefault();
        var href = $(this).attr("href");
		var x = screen.width/2 - 500/2;
		var y = screen.height/2 - 550/2;
		var slug = $(this).attr('rel');

		var ttl = $(this).attr("target");
		if (ttl=='_blank'){
			window.open(href, '_blank');
		}
		else{
			window.open(href, '_blank', 'height=550,width=500,left='+x+',top='+y);
		}
	});
});